import Services from './index.service';
import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { IItemDeclined } from 'models/portalModels/ItemDeclined';
import {
  IMapProduct,
  IMapProducts,
  IUpdateCompetitorPrice,
  UpdateConversionFactorProps,
  UpdateApprovedMapAutomaticProps,
  IMapProductAddOrUpdateViewModel
} from 'models/MapProduct';
import axios from 'axios';
import qs from "qs";

export default class quoteMapProductSevices extends Services<
  IMapProduct,
  IMapProduct
> {
  saveMapping = (data: Array<IMapProduct>) => {
    let config: IRequestConfig<Array<IMapProduct>> = {
      url: `${this.mafraq_url}/MapProduct/batch`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.post,
      data: { data: data },
    };
    return axios(config);
  };

  saveMapProduct = (data: IMapProductAddOrUpdateViewModel) => {
    let config: IRequestConfig<IMapProductAddOrUpdateViewModel> = {
      url: `${this.mafraq_url}/MapProduct/save-map-product`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.post,
      data: data
    };
    return axios(config);
  };

  savePriorityConversion = (data: string[], quoteId: string, sequenceNumber: string) => {
    let config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/MapProduct/priority-conversion-factor?quoteId=${quoteId}&sequenceNumber=${sequenceNumber}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.patch,
      data
    };
    return axios(config);
  };

  delete = (id: string) => {
    let config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/MapProduct/${id}`,
      method: MethodsTypes.delete,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return axios(config);
  };

  deleteSuggestionDetails = (id: string, quoteId: string, sequenceNumber: string, sequence: number) => {
    let config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/MapProduct/delete-suggestion-detail/${quoteId}/${sequenceNumber}/${id}/${sequence}`,
      method: MethodsTypes.delete,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return axios(config);
  };

  updateDeclinedItemReason = (quoteId: string, sequenceNumber: string, mapProductId: string, sequence: number, data?: IItemDeclined) => {
    let config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/MapProduct/update-declined-item-reason/${quoteId}/${sequenceNumber}/${mapProductId}/${sequence}`,
      method: MethodsTypes.put,
      data,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return axios(config);
  };
  changeOrder = (data: IMapProduct, e: any) => {
    let newSequence = e;
    let config: IRequestConfig<IMapProduct> = {
      url: `${this.mafraq_url}/MapProduct/change-priority-order?id=${data.id}&order=${newSequence}`,
      method: MethodsTypes.post,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      data,
    };
    return axios(config);
  };

  toggleProductOutPortfolio = (
    code: string,
    status: boolean
  ) => {
    let config: IRequestConfig<any> = {
      url: `${this.mafraq_url}/Product/out-of-portfolio?productCode=${code}&status=${status}`,
      method: MethodsTypes.post,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };
    return axios(config);
  };

  UpdateCompetitorPrice = (data: IUpdateCompetitorPrice) => {
    let config: IRequestConfig<IUpdateCompetitorPrice> = {
      url: `${this.mafraq_url}/MapProduct/UpdateCompetitorPrice`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.post,
      data
    };
    return axios(config);
  };

  getMapProducts = (data: IMapProducts, useMoney: boolean) => {
    const param = { ...data, useMoney };

    const config: IRequestConfig<IMapProducts> = {
      url: `${this.mafraq_url}/MapProduct/Map`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: param,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
      method: MethodsTypes.get
    };

    return axios(config);
  };

  UpdateApprovedMapAutomatic = (data: UpdateApprovedMapAutomaticProps) => {
    let config: IRequestConfig<UpdateApprovedMapAutomaticProps> = {
      url: `${this.mafraq_url}/MapProduct/UpdateApprovedMapAutomatic`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.post,
      data
    };
    return axios(config);
  };

  UpdateConversionFactor = (data: UpdateConversionFactorProps) => {
    let config: IRequestConfig<UpdateConversionFactorProps> = {
      url: `${this.mafraq_url}/MapProduct/UpdateConversionFactor`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
      method: MethodsTypes.post,
      data
    };
    return axios(config);
  };
}


